import { createAction } from "redux-actions";
import {
	checkLicense as checkLicenseApi,
	refreshLicense as refreshLicenseApi,
} from "../../services/about";

export enum ACTIONS {
	CHECK_LICENSE = "ABOUT/CHECK_LICENSE",
	REFRESH_LICENSE = "ABOUT/REFRESH_LICENSE",
	RESET_REFRESH_LICENSE = "ABOUT/RESET_REFRESH_LICENSE",
}

export const checkLicense = createAction(
	ACTIONS.CHECK_LICENSE,
	checkLicenseApi
);
export const refreshLicense = createAction(
	ACTIONS.REFRESH_LICENSE,
	refreshLicenseApi
);
export const resetRefreshLicense = createAction(ACTIONS.RESET_REFRESH_LICENSE);
